// extracted by mini-css-extract-plugin
export default {"editableMenuItem":"EditableMenuItem-module__editableMenuItem","icon":"EditableMenuItem-module__icon","img":"EditableMenuItem-module__img","text":"EditableMenuItem-module__text"};